import { c as _c } from "react/compiler-runtime";
import type { UnresolvedLink } from "contentful";
import { isEntry } from "@/lib/contentful/guards";
import { buildFaqJsonLd } from "@/lib/faq-jsonld";
import { AccordionLayout } from "@/types/contentful/AccordionLayout";
import type { TypeFaqItem } from "@/types/contentful/generated";
import { JsonLd } from "../JsonLd";
import { AccordionColumn } from "./AccordionColumn";
type FaqItemEntry = TypeFaqItem<undefined, string>;
type ItemBlock = FaqItemEntry | UnresolvedLink<"Entry">;
interface Props {
  title: string;
  layout: AccordionLayout;
  items?: ItemBlock[];
}
export default function AccordionComponent(t0) {
  const $ = _c(7);
  const {
    title,
    layout,
    items: t1
  } = t0;
  let t2;
  let t3;
  if ($[0] !== layout || $[1] !== t1 || $[2] !== title) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const items = t1 === undefined ? [] : t1;
      const allItems = items.filter(_temp);
      if (allItems.length === 0) {
        t3 = null;
        break bb0;
      }
      const faqJsonLd = buildFaqJsonLd(allItems);
      const isTwoColumn = layout === AccordionLayout.TwoColumn;
      const splitIndex = Math.ceil(allItems.length / 2);
      let t4;
      if ($[5] !== title) {
        t4 = <h2 className="heading-lg text-left">{title}</h2>;
        $[5] = title;
        $[6] = t4;
      } else {
        t4 = $[6];
      }
      t2 = <div className="p-6 w-full max-w-site-content mx-auto"><JsonLd data={faqJsonLd} />{t4}{isTwoColumn ? <div className="grid grid-cols-1 md:grid-cols-2 md:gap-8 mt-6"><AccordionColumn items={allItems.slice(0, splitIndex)} columnId="left" /><AccordionColumn items={allItems.slice(splitIndex)} columnId="right" /></div> : <div className="mt-6"><AccordionColumn items={allItems} columnId="single" /></div>}</div>;
    }
    $[0] = layout;
    $[1] = t1;
    $[2] = title;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  return t2;
}
function _temp(block) {
  return isEntry(block);
}